import { render, staticRenderFns } from "./ViewTokensModal.vue?vue&type=template&id=60a5c730&"
import script from "./ViewTokensModal.vue?vue&type=script&lang=js&"
export * from "./ViewTokensModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports